var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoincideConLaExpresionRegular({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_473_6032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2143 26H25.7857C26.7842 26 27.2834 26 27.6772 25.797C28.2022 25.5264 28.6194 25.0072 28.8369 24.3539C29 23.8637 29 23.2425 29 22C29 20.7575 29 20.1363 28.8369 19.6461C28.6194 18.9928 28.2022 18.4736 27.6772 18.2029C27.2834 18 26.7842 18 25.7857 18H17.2143C16.2158 18 15.7166 18 15.3228 18.2029C14.7978 18.4736 14.3806 18.9928 14.1631 19.6461C14 20.1363 14 20.7575 14 22C14 23.2425 14 23.8637 14.1631 24.3539C14.3806 25.0072 14.7978 25.5264 15.3228 25.797C15.7166 26 16.2158 26 17.2143 26Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 22C29 23.2425 29 23.8637 28.8369 24.3539C28.6194 25.0072 28.2022 25.5264 27.6772 25.797C27.2834 26 26.7842 26 25.7857 26H17.2143C16.2158 26 15.7166 26 15.3228 25.797C14.7978 25.5264 14.3806 25.0072 14.1631 24.3539C14 23.8637 14 23.2425 14 22M29 22C29 20.7575 29 20.1363 28.8369 19.6461C28.6194 18.9928 28.2022 18.4736 27.6772 18.2029C27.2834 18 26.7842 18 25.7857 18H17.2143C16.2158 18 15.7166 18 15.3228 18.2029C14.7978 18.4736 14.3806 18.9928 14.1631 19.6461C14 20.1363 14 20.7575 14 22M29 22H21.5H14",
    stroke: "#F4F4F4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_473_6032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoincideConLaExpresionRegular);
export default __webpack_public_path__ + "static/media/CoincideConLaExpresionRegular.d126ee444173abbe5813deddc2388c37.svg";
export { ForwardRef as ReactComponent };